import { createApiClient } from "@akhshy/client";
import { getToken, clearSession } from "./token.ts";

const baseUrl = import.meta.env.VITE_API_URL ?? "http://localhost:8787";

/** Handlers registered by the AuthProvider so a 401 can force a logout. */
let unauthorizedHandler: (() => void) | null = null;
export function setUnauthorizedHandler(fn: (() => void) | null): void {
  unauthorizedHandler = fn;
}

export const api = createApiClient({
  baseUrl,
  getToken,
  onUnauthorized: () => {
    clearSession();
    unauthorizedHandler?.();
  },
});

export { ApiClientError } from "@akhshy/client";
